import {
  DriverContainer,
  OrgLogoContainer,
  OrgName,
  RosterContainer,
  RosterDisplayNameContainer,
  RosterDriversContainer,
} from "./styles";
import { Panel } from "components/Panel/Panel";
import {
  selectRosterDisplayName,
  selectRosterScope,
  selectTournamentDriverDetails,
} from "selectors/Roster";
import { SQUAD_SCOPE } from "model/Roster/RosterScope";
import { useAppSelector } from "app/hooks";
import { isPlaceholderRosterId } from "model/Roster/Roster";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";

interface Props {
  rosterId: string;
  tournamentId: string;
}

export const RosterGridItem = ({ rosterId, tournamentId }: Props) => {
  const rosterScope = useAppSelector((state) =>
    selectRosterScope(state, tournamentId)
  );
  const rosterDisplayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );
  const driverDetails = useAppSelector((state) =>
    selectTournamentDriverDetails(state, rosterId, tournamentId)
  );

  const isPlaceholder = isPlaceholderRosterId(rosterId);
  const hasDrivers =
    rosterScope === SQUAD_SCOPE && !!driverDetails && driverDetails.length > 0;

  return (
    <Panel>
      <RosterContainer>
        <RosterDisplayNameContainer>
          <OrgLogoContainer>
            {!isPlaceholder && (
              <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
            )}
          </OrgLogoContainer>
          <OrgName>{rosterDisplayName}</OrgName>
        </RosterDisplayNameContainer>

        {hasDrivers && (
          <RosterDriversContainer>
            {driverDetails.map(({ id, name }) => (
              <DriverContainer key={id}>{name}</DriverContainer>
            ))}
          </RosterDriversContainer>
        )}
      </RosterContainer>
    </Panel>
  );
};
